import React, { Component } from "react"
import { Link } from "gatsby"

import FooterCtaBgImage from "../images/footer-cta.jpg"
import { FaAngleRight } from "react-icons/fa"

export default class FooterCta extends Component {
  render() {
    return (
      <>
        <section
          id="footer-cta"
          className="footer-cta py-24"
          style={{
            backgroundImage: "url(" + FooterCtaBgImage + ")",
            backgroundPosition: "center",
            backgroundRepeat: "no-repaet",
            backgroundSize: "cover",
            boxShadow: "inset 0 0 0 2000px rgba(0, 0, 0, 0.65)",
          }}
        >
          <div className="container mx-auto">
            <div class="flex flex-wrap">
              <div class="lg:w-1/2 w-full text-white justify-center items-center text-center lg:text-left lg:mb-0 mb-10 ">
                <h1 className="text-5xl">
                  Get your{" "}
                  <span>
                    business <br />
                    registered
                  </span>{" "}
                  with us.
                </h1>
              </div>
              <div class="lg:w-1/2 w-full flex lg:justify-end justify-center items-center">
                <Link
                  to="/"
                  className="btn-cta inline-flex  items-center px-8 py-4 font-normal"
                >
                  link your store &nbsp; &nbsp;
                  <FaAngleRight />
                </Link>
              </div>
            </div>
          </div>
        </section>
      </>
    )
  }
}
